// 주의: 이 모듈은 frontend/backend 공용 모듈임
const STATISTIC_FILTER_TYPE = ['GROUP1', 'GROUP2'];

/** B2E 온라인강의장 - 최근 수강한 코스 표시할 item 개수 */
const B2E_RECENT_ENROLLED_COURSE = {
  title: '최근 수강한 강의',
  count: 10,
};

const B2E_ME_STATISTICS_RECENT_ENROLLMENTS_VIEW_COUNT = 3;
const B2E_ME_ENROLLMENT_CERTIFICATION_DOWNLOADABLE_PERIOD_MONTH = 3;

/** @enum {string} */
const OrganizationType = {
  ORGANIZATION: 'ORGANIZATION',
  SCHOOL: 'SCHOOL',
};

/** @enum {string} */
const OrganizationTypeLabel = {
  ORGANIZATION: '기업',
  SCHOOL: '학교',
};

/** @enum {string} */
const OrganizationState = {
  NORMAL: 'NORMAL',
  PENDING: 'PENDING',
  HIDDEN: 'HIDDEN',
  DELETED: 'DELETED',
};

/** @enum {string} */
const OrganizationStateLabel = {
  NORMAL: '승인',
  PENDING: '대기',
  HIDDEN: '숨김',
  DELETED: '삭제',
};

const OrganizationExportFilter = {
  organizationId: { type: 'number' },
  employeeId: { type: 'number' },
  productIds: { type: 'array', elementType: 'number' },
  fileName: { type: 'string' },
  since: { type: 'date' },
  until: { type: 'date' },
};

const B2BExportLabels = ({ organizationType, headerType }) => {
  return {
    courseLabel: {
      name: '이름',
      email: '이메일',
      group1: organizationType === OrganizationType.ORGANIZATION ? '직무' : '단과',
      group2: organizationType === OrganizationType.ORGANIZATION ? '직급' : '학년',
      group3: organizationType === OrganizationType.ORGANIZATION ? '소속 부서/팀' : '학과',
      productType: '플랜 구분',
      productTitle: '플랜명',
      categoryTitle: '카테고리명',
      courseTitle: '강의명',
      assetPlayTime: '강의 시간(hh:mm:ss)',
      playTime: '수강 시간(hh:mm:ss)',
      progress: '수강률(%)',
      playTimeWithInPeriod: '기간 내 수강 시간',
      progressWithInPeriod: '기간 내 수강률(%)',
      state: '강의 상태',
      showAt: '수강 시작일',
      hideAt: '수강 종료일',
    },
    partLabel: {
      name: '이름',
      email: '이메일',
      group1: organizationType === OrganizationType.ORGANIZATION ? '직무' : '단과',
      group2: organizationType === OrganizationType.ORGANIZATION ? '직급' : '학년',
      group3: organizationType === OrganizationType.ORGANIZATION ? '소속 부서/팀' : '학과',
      productType: '플랜 구분',
      productTitle: '플랜명',
      categoryTitle: '카테고리명',
      courseTitle: '강의명',
      partTitle: '파트명',
      assetPlayTime: '파트 시간(hh:mm:ss)',
      playTime: '수강 시간(hh:mm:ss)',
      progress: '수강률(%)',
      playTimeWithInPeriod: '기간 내 수강 시간',
      progressWithInPeriod: '기간 내 수강률(%)',
      state: '강의 상태',
      showAt: '수강 시작일',
      hideAt: '수강 종료일',
    },
    employeeLabel: {
      customerName: '이름',
      customerEmail: '이메일',
      group1: organizationType === OrganizationType.ORGANIZATION ? '직무' : '단과',
      group2: organizationType === OrganizationType.ORGANIZATION ? '직급' : '학년',
      group3: organizationType === OrganizationType.ORGANIZATION ? '소속 부서/팀' : '학과',
      productCount: '플랜수',
      playTime: '전체 수강 시간',
      lastPlayAt: '최종 수강일시',
      updatedAt: '최종 수정일시',
      adminName: '최종 수정자',
    },
    employeeProductsLabel: {
      productTitle: '플랜명',
      courseTitle: '강의명',
      categoryTitle: '카테고리',
      progress: '수강률(%)',
      playTime: '수강 시간(hh:mm:ss)',
      firstPlayAt: '수강 시작 일시',
      lastPlayAt: '수강 최종 일시',
    },
    businessMyPageNotesLabel: {
      createdAt: '작성 시간',
      courseTitle: '코스명',
      partTitle: '파트명',
      clipTitle: '클립명',
      content: '노트',
    },
  }[headerType];
};

const B2BExportSheetName = {
  course: '강의별',
  part: '파트별',
  employee: '수강관리',
  employeeProducts: '수강상세',
  businessMyPageNotes: '노트',
};

const B2BStatisticDefaultCategoryLabels = [
  '데이터 사이언스',
  '마케팅',
  '비즈니스',
  '크리에이티브',
  '파이낸스',
  '프로그래밍',
];

module.exports = {
  STATISTIC_FILTER_TYPE,
  B2E_ME_STATISTICS_RECENT_ENROLLMENTS_VIEW_COUNT,
  B2E_ME_ENROLLMENT_CERTIFICATION_DOWNLOADABLE_PERIOD_MONTH,
  B2E_RECENT_ENROLLED_COURSE,
  OrganizationType,
  OrganizationTypeLabel,
  OrganizationState,
  OrganizationStateLabel,
  OrganizationExportFilter,
  B2BExportLabels,
  B2BExportSheetName,
  B2BStatisticDefaultCategoryLabels,
};
